import type { WordsType } from './i18n/words.js';

/**
 * How long ago a timestamp was, in the words `/infrastructure` already uses, so every screen agrees,
 * in the caller's language (`t`; `ENGLISH_ACTIVITY_WORDS` for an English sentence).
 *
 * Its own module so a launch-time reader of it (the load-failure banner's "Showing data from …") does
 * not bring the whole presence derivation with it into the web app's entry chunk (T-0559). The
 * derivation re-exports it, so every other import keeps working.
 */
export function presenceAgeLabel(isoTimestamp: string, nowMs: number, t: WordsType): string {
  const at = Date.parse(isoTimestamp);
  if (Number.isNaN(at)) return t('activityWords.presenceAge.unknown');
  const seconds = Math.max(0, Math.round((nowMs - at) / 1000));
  if (seconds < 60) return t('activityWords.presenceAge.justNow');
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return t('activityWords.presenceAge.minutes', { count: minutes });
  const hours = Math.round(minutes / 60);
  if (hours < 24) return t('activityWords.presenceAge.hours', { count: hours });
  return t('activityWords.presenceAge.days', { count: Math.round(hours / 24) });
}
